export default "__VITE_ASSET__$radCrV7__"